import {createType, createAction} from 'store/utils';

const prefix = 'SETTINGS';

export const CHANGE_TEMPORARY_DATE = createType(prefix, 'CHANGE_TEMPORARY_DATE');
export const changeTemporaryDate = (value: UnixTimeStamp): Action =>
  createAction(CHANGE_TEMPORARY_DATE, value);
